import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  private _isRefreshing = false;
  private _refreshTokenSubject$ = new BehaviorSubject<string>(null);

  setRefreshing(isRefreshing: boolean): void {
    this._isRefreshing = isRefreshing;
  }

  isTokenRefreshing(): boolean {
    return this._isRefreshing;
  }

  setRefreshToken(token: string): void {
    this._refreshTokenSubject$.next(token);
  }

  getRefreshToken$(): Observable<string> {
    return this._refreshTokenSubject$.pipe(
      filter((token): token is string => token !== null),
      take(1),
    );
  }
}
